import { styled } from '@mui/system';
import styled2 from 'styled-components';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
	FlexContainer,
	MD_LG_SECTION_HEADER,
	MD_LG_PARA_1,
} from '@silverrailtech/srtlibrary';
import { limeGreen, red, textPrimary1 } from '../../../../colors';

export const SpinnerWrapper = styled(FlexContainer)({
	height: '82px',
	width: '110px',
	'& > .spinner-padding': {
		paddingTop: '24px !important',
	},
});

export const DialogTitle = styled2.h2`
	margin: 0 0 16px 0;
	${MD_LG_SECTION_HEADER}
`;

export const SuccessIcon = styled(CheckCircleOutlineIcon)({
	color: limeGreen,
	width: '64px',
	height: '64px',
});

export const ErrorIcon = styled(ErrorOutlineIcon)({
	color: red,
	width: '64px',
	height: '64px',
});

export const FailedTicketParagraph = styled2.p`
	${MD_LG_PARA_1};
	color: ${textPrimary1} !important;
	margin: 0;
`;
